import { useEffect, useState } from "react";
import { api } from "./api";

// Names of the logins that can work Leads (admins + anyone granted the `leads`
// allowance + Redline accounts). Drives every "who contacted" picker so granting
// someone Leads access is all it takes for them to appear.
export function useLeadsTeam() {
  const [names, setNames] = useState([]);
  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const { data } = await api.get("/team", { params: { perm: "leads" } });
        if (cancel) return;
        const seen = new Set();
        const out = [];
        for (const m of data || []) {
          const n = (m?.name || "").trim();
          if (!n || seen.has(n.toLowerCase())) continue;
          seen.add(n.toLowerCase());
          out.push(n);
        }
        setNames(out.sort((a, b) => a.localeCompare(b)));
      } catch {
        /* picker falls back to whatever name is already saved */
      }
    })();
    return () => { cancel = true; };
  }, []);
  return names;
}
